import axios from "axios";
import {
  fullAPIURL,
} from "../utils/requests";
import { refreshAccessTokenInterceptor } from "../utils/refreshTokens";
import {
  requestAccessTokenInterceptor,
  responseStatusInterceptor,
} from "../utils/axios.utils";
import { PlanTypeApiName } from "../pages/Plans/plan.types";
const planAxios = axios.create({
  baseURL: `${fullAPIURL}/v2/plans`,
  headers: { "Content-Type": "application/json" },
  validateStatus: null,
});

planAxios.interceptors.request.use(requestAccessTokenInterceptor);
planAxios.interceptors.request.use(refreshAccessTokenInterceptor);
planAxios.interceptors.response.use(responseStatusInterceptor);

export interface PlanPriceRecommendationRow {
  gymType: string;
  countryName: string;
  countryIso3: string;
  planType: PlanTypeApiName;
  medianAmount: number;
  p25Amount: number;
  p75Amount: number;
  numberOfGyms: number;
  numberOfPlans: number;
  numberOfUsers: number;
  numberOfSubscriptions: number;
}

export type PlanPriceRecommendationData = PlanPriceRecommendationRow[];

export interface GetPlanPriceRecommendationsResult {
  data: PlanPriceRecommendationData;
}

export async function getPlanPriceRecommendations() {
  const url = "/price-recommendations";
  const response = await planAxios.get<PlanPriceRecommendationData>(url);
  return response.data;
}
